import React from 'react';
import { get } from 'lodash-es';
import { defineMessages } from 'react-intl';
import { createSelector } from 'reselect';
import { BulkActions } from '../../../../enums/bulk-actions';
import { Confirmations } from '../../../../enums/confirmation';
import { ConfirmationDropdown } from './confirmation-dropdown';

const messages = defineMessages({
  requestConfirmation: {
    description: 'bulkActions.requestConfirmation',
    defaultMessage: 'Request Confirmation',
    id: 'Skz5g8',
  },
});

export const updateConfigConfirmationSelector = createSelector(
  (onChange) => onChange,
  (_, model) => model,
  (onChange, model) => {
    return (conf) => {
      const confirmationTypes = Object.values(Confirmations).map((_, ordinal) => ({
        confirmationId: ordinal.toString(),
      }));
      const selectedConfirmationType = confirmationTypes.find((type) => type.confirmationId === conf);
      const { shippingConfiguration = {} } = model;
      const { options } = shippingConfiguration;
      const payload = !selectedConfirmationType
        ? model
        : {
            ...model,
            shippingConfiguration: {
              ...shippingConfiguration,
              options: {
                ...options,
                confirmation: {
                  confirmationId: selectedConfirmationType.confirmationId,
                },
              },
            },
          };
      onChange(payload);
    };
  },
);

export const Confirmation = {
  id: BulkActions.confirmation.name,

  render: (onChange, model, jobData, isEmpty) => {
    const shippingConfiguration = get(model, 'shippingConfiguration');
    const options = get(shippingConfiguration, 'options');
    const selectedConfirmation = get(options, 'confirmation.confirmationId');

    return (
      <ConfirmationDropdown
        dropdownMenuShouldHaveWidthOfButton
        hasError={isEmpty}
        labelMessage={messages.requestConfirmation}
        onConfirmationSelected={updateConfigConfirmationSelector(onChange, model)}
        selectedConfirmation={selectedConfirmation}
      />
    );
  },
};
